/**
 * Shared meta / PWA values for document head and favicon manifest.
 * Used by __root.tsx and scripts/generate-favicons.
 */
export const APP_META = {
  title: 'TILDA – Geodaten für die Verkehrsplanung',
  shortName: 'TILDA',
  description:
    'TILDA bringt Ihnen Geodaten für die Verkehrsplanung – nachhaltig und für die Nutzung im Team.',
  themeColor: '#27272a',
} as const
